import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import constants from "../period-calculator-constants/OC_Constants";
import DatePicker from "react-datepicker";
import addDays from "date-fns/addDays";
import Customdatepicker from "../period-calculator-landing-page/Customdatepicker";
import { isMobile } from "react-device-detect";
import "react-datepicker/dist/react-datepicker.css";
import "../period-calculator-landing-page/PeriodLayout.css";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import ReminderDropDown from "./ReminderDropDown";
import WeeklyDropdown from "./WeeklyDropdown";
import FrequencyDropDown from "./FrequencyDropDown";
import { registerLocale } from  "react-datepicker";
import enIN from 'date-fns/locale/en-IN';
registerLocale('enIN', enIN)

const currentdate = new Date();
const defaultview = true;

class PillsInjectionsData extends React.PureComponent {
  // Setting component default state here
  state = {
    dayValue: new Date().getDate(), // used for default selected value in dropdown
    monthValue: new Date().getMonth(), // used for default selected value in dropdown
    yearValue: new Date().getFullYear(), // used for default selected value in dropdown,
    reminderTime: this.props.goalData.timeDropDownDefaultItem,
    weeeklyReminderTime: "7",
    frequencyReminderTime: "14",
    reminderTileList: this.props.goalData.timeDropDownItems,
    frequencyList: this.props.componentData.frequencyDropdownItems,
    // reminderTileList: [
    //     {fields: { key: '9:00 AM', value: '9' } },
    //     { fields: { key: '10:00 AM', value: '10' } },
    //     { fields: { key: '11:00 AM', value: '11' }},
    //     { fields: { key: '12:00 AM', value: '12' } }
    // ],
    isPeriodChange: false,
    isCycleChange: false,
    showPlus: false,
    showRangeSlider: false,
    dplabel: this.props.componentData.startDateSelectionLabel.value,
    startDate: null,
    currentDate: new Date(),
    lastPeriodDateLogo: this.props.parentCompData.datePickerLogo.value,
    copen: defaultview,
  };

  // This is LifeCycle method used to setup the default data for rendering
  componentDidMount() {
    // document.addEventListener('click', this.handleClickOutside);
    let {
      dayValue,
      monthValue,
      yearValue,
      reminderTime,
      weeeklyReminderTime,
      frequencyReminderTime,
    } = this.props.currentMonthCycle;
    this.setState(
      (prevState, props) => {
        return {
          startDate: new Date(yearValue, monthValue, dayValue),
          reminderTime: reminderTime,
          weeeklyReminderTime: weeeklyReminderTime,
          frequencyReminderTime: frequencyReminderTime,
        };
      },
      () => {
        this.props.sendLastPeriodData(
          this.state.dayValue,
          Number(this.state.monthValue),
          this.state.yearValue,
          this.state.cycleLengthValue,
          this.state.periodDuration,
          true,
          reminderTime,
          weeeklyReminderTime,
          frequencyReminderTime
        );
      }
    );
  }

  componentDidUpdate(nextProps) {
    let {
      cycleLength,
      periodDuration,
      dayValue,
      monthValue,
      yearValue,
      reminderTime,
      weeeklyReminderTime,
      frequencyReminderTime,
    } = this.props.currentMonthCycle;
    if (
      nextProps.selectedTrack !== this.props.selectedTrack ||
      nextProps.currentMonthCycle.reminderTime.fields.key.value !==
        this.props.currentMonthCycle.reminderTime.fields.key.value
    ) {
      this.setState((prevState, props) => {
        return {
          startDate: new Date(yearValue, monthValue, dayValue),
          cycleLengthValue: cycleLength,
          periodDuration: periodDuration,
          reminderTime: reminderTime,
          weeeklyReminderTime: weeeklyReminderTime,
          frequencyReminderTime: frequencyReminderTime,
          frequencyList: this.props.componentData.frequencyDropdownItems,
        };
      });
      if (document.getElementById("calculate-period-button-id"))
        document.getElementById("calculate-period-button-id").disabled = false;
    }
  }

  changeDate = (date) => {
    this.setState(
      (prevState, props) => {
        return { startDate: date, copen: false };
      },
      () => {
        this.props.sendLastPeriodData(
          new Date(date).getDate(),
          new Date(date).getMonth(),
          new Date(date).getFullYear(),
          this.state.cycleLengthValue,
          this.state.periodDuration,
          true,
          this.state.reminderTime,
          this.state.weeeklyReminderTime,
          this.state.frequencyReminderTime
        );
      }
    );
  };

  ReminderTimeChange = (timeObj, valueChanged) => {
    this.setState({
      reminderTime: timeObj,
    });
    this.props.sendLastPeriodData(
      new Date(this.state.startDate).getDate(),
      new Date(this.state.startDate).getMonth(),
      new Date(this.state.startDate).getFullYear(),
      this.state.cycleLengthValue,
      this.state.periodDuration,
      true,
      timeObj,
      this.state.weeeklyReminderTime,
      this.state.frequencyReminderTime
    );
  };

  WeeklyReminderTimeChange = (weeklyObj, valueChanged) => {
    this.setState({
      weeeklyReminderTime: weeklyObj.key.value,
    });
    this.props.sendLastPeriodData(
      new Date(this.state.startDate).getDate(),
      new Date(this.state.startDate).getMonth(),
      new Date(this.state.startDate).getFullYear(),
      this.state.cycleLengthValue,
      this.state.periodDuration,
      true,
      this.state.reminderTime,
      weeklyObj.key.value,
      this.state.frequencyReminderTime
    );
  };

  frequencyReminderTimeChange = (weeklyObj, valueChanged) => {
    this.setState({
      frequencyReminderTime: weeklyObj.key.value,
    });
    this.props.sendLastPeriodData(
      new Date(this.state.startDate).getDate(),
      new Date(this.state.startDate).getMonth(),
      new Date(this.state.startDate).getFullYear(),
      this.state.cycleLengthValue,
      this.state.periodDuration,
      true,
      this.state.reminderTime,
      this.state.weeeklyReminderTime,
      weeklyObj.key.value
    );
  };

  render() {
    let {
      cycleLengthValue,
      isPeriodChange,
      isCycleChange,
      reminderTime,
    } = this.state;
    let avgPeriodTextColor = isPeriodChange ? "#212529" : "#bfccdd";
    let cycleLengthTextColor = isCycleChange ? "#212529" : "#bfccdd";
    let currentmonthdays = new Date(
      this.state.currentDate.getFullYear(),
      this.state.currentDate.getMonth(),
      0
    ).getDate();
    let prevmonthdays = new Date(
      this.state.currentDate.getFullYear(),
      this.state.currentDate.getMonth() - 1,
      0
    ).getDate();
    let mindate = new Date(
      this.state.currentDate.getFullYear(),
      this.state.currentDate.getMonth() - 1,
      1
    );
    let maxdate = prevmonthdays + currentmonthdays;
    return (
      <>
        <div className="calculator-field" data-test="last-period">
          <div className="field field-datepicker">
            <label>
              {this.props.componentData.startDateSelectionLabel.value}
              <a
                className="ttlink"
                alt={this.props.componentData.startDateSelectionTooltip.value}
              >
                <i className="fa fa-question-circle"></i>
                <span>
                  {this.props.componentData.startDateSelectionTooltip.value}
                </span>
              </a>
            </label>
            <DatePicker
              locale="enIN"
              //ref={this.calendarRef}
              minDate={new Date()}
              // maxDate={addDays(new Date(this.state.currentDate.getFullYear(), this.state.currentDate.getMonth() - 1, 1), maxdate)}
              maxDate={
                new Date(
                  this.state.currentDate.getFullYear(),
                  this.state.currentDate.getMonth() + 1,
                  new Date(
                    this.state.currentDate.getFullYear(),
                    this.state.currentDate.getMonth(),
                    0
                  ).getDate()
                )
              }
              // maxDate={new Date()}
              dateFormat="dd MMMM, yyyy"
              showPopperArrow={false}
              selected={this.state.startDate}
              onChange={(date) => this.changeDate(date)}
              customInput={
                <Customdatepicker
                  imagepath={this.state.lastPeriodDateLogo}
                  placeholder="Select a date"
                />
              }
              showPreviousMonths={this.state.copen ? true : false}
              //showDisabledMonthNavigation
              // monthsShown={this.state.monthtoshown}
              //onInputClick={() => this.handleCalendarOpen()}
              //onClickOutside={() => this.handleCalendarClose(this)}
              //onClickOutside={() => {this.calendarRef.setOpen(false)}}>
              //open={this.state.copen}
              placeholderText="Select a date"
            ></DatePicker>
          </div>
        </div>

        <div className="duration-wrap">
          <label>
            {this.props.componentData.timeSelectionLabel.value}
            <a
              className="ttlink"
              alt={this.props.componentData.timeSelectionTooltip.value}
            >
              <i className="fa fa-question-circle"></i>
              <span>{this.props.componentData.timeSelectionTooltip.value}</span>
            </a>
          </label>
          <ReminderDropDown
            onReminderTimeChange={(timeObj, valueChange) =>
              this.ReminderTimeChange(timeObj, valueChange)
            }
            list={this.state.reminderTileList}
            defaultSelectedValue={
              (reminderTime.key && reminderTime.key.value) ||
              reminderTime.fields.key.value
            }
          />
        </div>

        {this.props.selectedTrack === "HYGIENE" && (
          <div className="duration-wrap">
            <label>
              {this.props.componentData.frequencySelectionLabel.value}
              <a
                className="ttlink"
                alt={this.props.componentData.frequencySelectionTooltip.value}
              >
                <i className="fa fa-question-circle"></i>
                <span>
                  {this.props.componentData.frequencySelectionTooltip.value}
                </span>
              </a>
            </label>
            <FrequencyDropDown
              onReminderTimeChange={(timeObj, valueChange) =>
                this.frequencyReminderTimeChange(timeObj, valueChange)
              }
              list={this.props.componentData.frequencyDropdownItems}
              defaultValue={this.state.frequencyReminderTime}
            />
          </div>
        )}

        {this.props.selectedTrack === "PILLS" && (
          <div className="duration-wrap">
            <label>
              {this.props.componentData.durationSelectionLabel.value}
              <a
                className="ttlink"
                alt={this.props.componentData.durationSelectionToolTip.value}
              >
                <i className="fa fa-question-circle"></i>
                <span>
                  {this.props.componentData.durationSelectionToolTip.value}
                </span>
              </a>
            </label>
            <WeeklyDropdown
              onReminderTimeChange={(timeObj, valueChange) =>
                this.WeeklyReminderTimeChange(timeObj, valueChange)
              }
              list={this.props.componentData.durationDropDownItems}
              defaultValue={this.state.weeeklyReminderTime}
            />
          </div>
        )}
      </>
    );
  }
}

export default withTranslation()(PillsInjectionsData);
